export { default as BitacoraListar } from './Listar'
export { default as BitacoraDetalle } from './Detalle'
